module.exports = __webpack_public_path__ + "img/completingItem.78e6f246.gif";